
import activate from './activate';

export default [
  ...activate,
];
